import { useUIStore } from '@/stores/uiStore';
import type { Insight } from '@/types';

// Receives the already-computed insight from the parent (Narrator) so the
// expensive useSkipIntelligence scan runs once per render, not twice.
export function InsightCard({ insight }: { insight: Insight }) {
  const dismiss = useUIStore((s) => s.dismissInsight);
  return (
    <div className="rounded-xl border border-line-2 bg-card p-3">
      {/* v4: insight copy is the Narrator's voice — Literata italic, visibly
          a different register from UI chrome. */}
      <div className="font-display text-body-lg italic leading-snug text-t1">{insight.copy}</div>
      <button
        type="button"
        onClick={() => dismiss(insight.id)}
        className="mt-2 rounded text-caption text-t3 underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
      >
        Dismiss
      </button>
    </div>
  );
}
